import React, { Component } from "react";
import { Row, Col } from "reactstrap";
import Tables from "../Base/Tables/Tables";
import ChiffresClesBienEtreRessenti from "../Base/ChiffresClesBienEtreRessenti/ChiffresClesBienEtreRessenti";
import ChartsBienEtreRessenti from "../Base/ChartsBienEtreRessenti/ChartsBienEtreRessenti";

class AdminBienEtreRessenti extends Component {

    constructor(props) {
      super(props);
      this.state = {
        newFetch: false,
        error: false
      };
    }

    updateData() {
      try {
        this.setState({ newFetch: !this.state.newFetch });
      } catch (e) {
        console.log(e);
      }
    }

    componentDidUpdate(prevProps, prevState) {
      if (prevState.error) {
        this.setState({ error: false });
      }
    }

    notifyError() {
      toast.error(
        "Les tags sélectionnés sont trop précis, merci de sélectionner moins de tags."
      );
      this.setState({ error: true });
    }

    getTagsRequest() {
      let res = "";
      if (window.selectedTags) {
        window.selectedTags.forEach(tag => {
          res.length
            ? (res = res + "&tags[]=" + tag)
            : (res = res + "?tags[]=" + tag);
        });
      }
      return res;
    }


  render() {
    return (
      <div className="animated fadeIn">
        <ChiffresClesBienEtreRessenti
          request={"/" + this.props.params.id}
          isAdmin={true}

        />
        <Row>
          <Col>
            <Tables
              tableType="resultsByUniverses"
              id={this.props.params.id}
              perPage={3}
            />
          </Col>
        </Row>
        <ChartsBienEtreRessenti
          request={"/" + this.props.params.id}
          isAdmin={false}
          notifyError={this.notifyError.bind(this)}
          error={this.state.error}
          newFetch={this.state.newFetch}
        />
        <Row>
          <Col>
            <Tables
              tableType="resultsByThematics"
              id={this.props.params.id}
              perPage={12}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <Tables
              tableType="resultsByQuestions"
              id={this.props.params.id}
              perPage={20}
            />
          </Col>
        </Row>
      </div>
    );
  }
}

export default AdminBienEtreRessenti;



// WEBPACK FOOTER //
// ./src/views/AdminBienEtreRessenti/AdminBienEtreRessenti.js